import axiosInstance from '../api'; // Adjust the import based on your file structure
import { notification } from 'antd';

export const loginUser = async (credentials) => {
  try {
    const response = await axiosInstance.post('/auth/admin_login', credentials);

    if (response.data.status_code === 200) {
      return response.data.data; // Return the token data if successful
    } else {      
      notification.error({
        message: 'Login Error',
        description: response.data.message || 'An error occurred during login.',
        duration: 3,
      });
      const error_res ={
        'is_failed': true,
        'attempt_message': response.data.attempt_message || ''
      }
      return error_res
    }
  } catch (error) {
    // If an error occurs during the request, display a generic error message
    notification.error({
      message: 'Login Error',
      description: error.response?.data?.message || 'Failed to log in.',
      duration: 3,
    });
    throw new Error('Login failed');
  }
};

export const verifyAdminOtp = async (otp, tempToken) => {
  try {
    const response = await axiosInstance.post("/auth/admin-verify-otp", {
      otp,
      temp_token: tempToken,
    });
    return response.data; // Make sure to return `.data`, not `.response`
  } catch (error) {
    notification.error({
      message: 'Verify Error',
      description: error.response?.data?.message || 'Failed to Verify Admin Otp',
      duration: 3,
    });
    throw new Error('verifyAdminOtp failed');
  }
};

export const resendAdminOtp = async (tempToken) => {
    try {
        const response = await axiosInstance.post("/auth/admin-resend-otp", {
            temp_token: tempToken,
        });
        return response.data;
    } catch (error) {
      notification.error({
        message: 'Verify Error',
        description: error.response?.data?.message || 'Failed to Resend OTP',
        duration: 3,
      });
      throw new Error('Resend OTP failed');
    }
};
